import styled, { css } from 'styled-components';

import { TextButton } from '@xing-com/button';
import {
  spaceS,
  spaceL,
  spaceXS,
  spaceXXS,
  xdlColorBorderSoft,
} from '@xing-com/tokens';

type ActionButtonProps = {
  $isBottom?: boolean;
  $isTop?: boolean;
  $noMargin?: boolean;
};

const getBottomButtonCss = (noMargin = false): ReturnType<typeof css> => css`
  justify-content: flex-start;
  border-top: 1px solid ${xdlColorBorderSoft};
  margin-top: ${noMargin ? 0 : spaceXS};
  padding-top: ${spaceS};
`;

const getTopButtonCss = (): ReturnType<typeof css> => css`
  position: absolute;
  top: ${spaceL};
  right: ${spaceL};
`;

export const ActionButtons = styled.div<ActionButtonProps>`
  display: flex;
  justify-content: flex-end;
  ${({ $isBottom, $isTop, $noMargin }) =>
    $isBottom && !$isTop && getBottomButtonCss($noMargin)}
  ${({ $isBottom, $isTop }) => !$isBottom && $isTop && getTopButtonCss()}

  @media print {
    display: none;
  }
`;

export const Button = styled(TextButton)`
  & span:last-of-type {
    margin-top: ${spaceXXS};
  }
`;
